/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';

export const getMostUsedPaymentMethods = async (jwt) => {
    const wcEnv = { rootUri: '/' };
    const resourcePage = 'customer-personalize/paymentMethods/allPaymentMethodsByUsage';
    const response = await restClient.getFacade(wcEnv, resourcePage, jwt, null, null, false);
    return response;
};

export default {};
